<template>
  <div>
      <h3 v-if="msguser && msguser != ''" style="color:green;text-shadow:0px 0px 3px #a5a5a5">
        {{ msguser }}
      </h3>
      <div>

          <!-- VIEWING CONFIRMATION -->
          <div class="booking__confirmation" style="text-align:center">
            <div>
              <div v-if="textStep == 0">
                <p>Before we submit your viewing request we need you to confirm your mobile number.</p><br>
                <p>We will send a message to:</p>
              </div>
              <div v-if="textStep == 1">
                <div class="booking__confirmation__icon"><i class="ico ico-checkmark"></i></div>
                <p>Thank you, we have sent you a text message to:</p>
              </div>
              <div class="width-40 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top" style="max-width:120px">
								 <input id="mobile" type="tel" v-model="tempMobile" class="mdc-textfield__input" name="mobile" placeholder="07---------" inputmode="numeric" pattern="[0-9]*"> <i class="ico ico-edit" style="margin-bottom: 10px"></i>
								 <label for="mobile" class="mdc-textfield__label mdc-textfield__label--float-above">Mobile Number</label>
							</div>
              <div class="error" v-if="confirmationError != ''">{{confirmationError}}</div>
              <p>As soon as you have confirmed we can continue with your viewing request.</p>
              <p>
                <br>
                <button id="btnMobile" class="mdc-button mdc-button-submit btn--spinner btn--spinner__wide-btn" style="font-size:22px" @click="confirmContact">SUBMIT</button>
              </p>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import api from '@/libs/api.js';
import axios from 'axios';


export default {
	props: {
		booking: Object
	},
	data: function() {
		return {
      textStep: 0,
      confirmingMobile: false,
      tmpWidth: '',
      tmpHTML: '',
      confirmationError: '',
      tempMobile: '',
      msguser: undefined,
		}
	},
	created: async function() {
    const booking = this.booking;
    this.tempMobile = booking.user.mobile;
    //if (!this.tempMobile || this.tempMobile == null || this.tempMobile == '') {
    //  this.tempMobile = "07";
    //}
  },
	methods: {
		showSpinner(id) {
			var element = document.getElementById(id);
      this.tmpWidth = element.style.width;
      this.tmpHTML = element.innerHTML;
      element.style.width = "220px";
      element.innerHTML = "Sending";
			element.classList.add('btn-spin--visible');
		},
		hideSpinner(id) {
			var element = document.getElementById(id);
      element.style.width = this.tmpWidth;
      element.innerHTML = this.tmpHTML;
			element.classList.remove('btn-spin--visible');
      this.triggerSent(element);
		},
    triggerSent(element) {
      this.textStep = 1;
			element.classList.add('mdc-button--raised');
      //element.style.border = '1px solid green';
      //element.style.color = "green";
      element.innerHTML = "Sent";
      setTimeout(function() {
        element.innerHTML = "Resend SMS";
      },1000);
    },
		confirmContact() {
      this.showSpinner('btnMobile');
			const that = this;

			this.confirmationError = '';

			let params = {
				companyId: this.booking.company.companyId,
				applicantId: this.booking.user.applicantId,
        mobile: this.tempMobile
			};
			// trigger confirm contact
			axios.patch(`${this.config.services.applicants}/sendConfirmation`, params)
			.then(function(response) {
				if(response.data.success) {
          that.booking.user.mobile = that.tempMobile;
          if (that.confirmingMobile == false) {
            that.confirmingMobile = true;
            setInterval(async function() {
              if (that.$parent.booking.user.mobileConfirmed != true) {
                await that.$parent.getBooking();
              }
            },10000);
          }
          that.hideSpinner('btnMobile');
				} else {
					if(response.data.errorCode == 'mobile-exists') {
						that.confirmationError = 'Sorry, your mobile number is already registered with '+that.$parent.booking.company.companyName+".";
					}
          that.hideSpinner('btnMobile');
				}
			})
			.catch(function(error) {
				console.error('error:', error);
        that.hideSpinner('btnMobile');
			});
		},
    msgUser(msg) {
      this.msguser = msg;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/booking/confirmmobile.vue